module.exports = __webpack_public_path__ + "static/hero-9c2200fd3129e73d94dbbcc971b66157.jpg";